import { useContext } from 'react'

import { SingleAiResponseContext } from '../context/SingleAiResponseContext'

export const useSingleAiResponseContext = () => {
    return useContext(SingleAiResponseContext);
}